    function setColSlider() {
    const collectionSection = document.querySelector(".collections-row")
    if(!collectionSection) return
    const collectionScroll = collectionSection.querySelector('.collections-row_slider');
    const leftBtn = collectionSection.querySelector("button[id*='_collections-row_button_left']");
    const rightBtn = collectionSection.querySelector("button[id*='_collections-row_button_right']");
    const progressBarFill = collectionSection.querySelector('.progress-bar-fill');
    const scrollWidth = collectionScroll.scrollWidth;
    const clientWidth = collectionScroll.clientWidth;

    const maxScroll = scrollWidth - clientWidth;
    const scrollStep = clientWidth * 0.5;
    console.log(maxScroll)
    if (maxScroll > 0) {
      document.querySelector('.collection_row_section_bottom').style.display = 'flex';
    }
    let scrollOffset = 0;
    leftBtn.addEventListener('click', function () {
      if (scrollOffset > 0) {
        scrollOffset -= scrollStep;
        collectionScroll.style.transform = `translateX(-${scrollOffset}px)`;
        const percent = (scrollOffset / maxScroll) * 100;
        progressBarFill.style.width = `${percent}%`;
      }
    });
    rightBtn.addEventListener('click', function () {
      if (scrollOffset < maxScroll) {
        scrollOffset += scrollStep;
        collectionScroll.style.transform = `translateX(-${scrollOffset}px)`;
        const percent = (scrollOffset / maxScroll) * 100;
        progressBarFill.style.width = `${percent}%`;
      }
    });
  }
  document.addEventListener('DOMContentLoaded', setColSlider);
  window.addEventListener('resize', setColSlider);